<template>
  <div class="mainContent settings hor-padding-5 hor-padding-30-ms">
    <ul class="submenu grid">
      <li>
        <router-link :to="{ name: 's_Users' }">Пользователи</router-link>
      </li>
      <li>
        <router-link :to="{ name: 's_Merchants' }">Предприятия</router-link>
      </li>
      <li>
        <router-link :to="{ name: 's_Terminals' }">Терминалы</router-link>
      </li>
      <li>
        <router-link :to="{ name: 's_Processings' }">Процессинги</router-link>
      </li>
      <li>
        <router-link :to="{ name: 's_Whitelist' }">IP Whitelist</router-link>
      </li>
    </ul>
    <div class="u-16 grid">
      <div class="settings_content u-16">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Settings",
  data() {
    return {
      activeName: "users"
    };
  },
  created() {
    this.$store.dispatch("getMerchant");
    this.$store.dispatch("getTerminal");
    this.$store.dispatch("getProcessing");
  }
};
</script>

<style lang="sass" scoped>
.submenu
  font-family: "Avenir", sans-serif
  font-weight: 500
  margin-top: 30px
  li
    margin-right: 35px
  a
    color: #364E65
  a.active
    color: #3796F6
</style>
